module.exports = __webpack_public_path__ + "static/media/status_ilustrasi.4b155abe.png";